module.exports = __webpack_public_path__ + "static/media/customer.2b302be3.png";